import type { ShareButtonProps } from "@op/puck-types";
import { DropdownMenu, IconButton } from "@op/sf-op";
import {
  getCurrentUrl,
  makeEmailLink,
  makeFacebookShareLink,
  makeLinkedInShareLink,
  makeMastodonShareLink,
  makeTwitterShareLink,
  useRender,
  useTheme,
} from "@op/utils";
import {
  FeatherMail,
  FeatherShare2,
  FeatherTwitter,
  FeatherLinkedin,
  FeatherFacebook,
  //   FeatherMastodon,
  FeatherCopy,
  DropdownMenu as SfCDropdownMenu,
} from "@subframe/core";
import { useCallback, useMemo } from "react";

const ShareButton = ({ size = "medium" }: ShareButtonProps) => {
  const { context } = useRender();
  const isNotRenderer = useMemo(() => context !== "renderer", [context]);
  const currentUrl = useMemo(() => getCurrentUrl(), []);

  const onCopyLinkClick = useCallback(
    () => navigator.clipboard.writeText(currentUrl),
    [currentUrl]
  );

  const emailLink = useMemo(() => makeEmailLink(currentUrl), [currentUrl]);
  const facebookLink = useMemo(
    () => makeFacebookShareLink(currentUrl),
    [currentUrl]
  );
  const linkedInLink = useMemo(
    () => makeLinkedInShareLink(currentUrl),
    [currentUrl]
  );
  const twitterLink = useMemo(
    () => makeTwitterShareLink(currentUrl),
    [currentUrl]
  );
  const _mastodonLink = useMemo(
    () => makeMastodonShareLink(currentUrl),
    [currentUrl]
  );

  const { container: _container } = useTheme();

  return (
    <SfCDropdownMenu.Root>
      <SfCDropdownMenu.Trigger asChild>
        <IconButton
          disabled={isNotRenderer}
          size={size}
          icon={<FeatherShare2 />}
          variant="neutral-secondary"
        />
      </SfCDropdownMenu.Trigger>
      <SfCDropdownMenu.Content className="z-20">
        <DropdownMenu>
          <a className="contents" href={emailLink}>
            <DropdownMenu.DropdownItem icon={<FeatherMail />}>
              E-Mail
            </DropdownMenu.DropdownItem>
          </a>
          <a
            className="contents"
            target="_blank"
            referrerPolicy="no-referrer"
            href={twitterLink}
          >
            <DropdownMenu.DropdownItem icon={<FeatherTwitter />}>
              Twitter
            </DropdownMenu.DropdownItem>
          </a>
          <a
            className="contents"
            target="_blank"
            referrerPolicy="no-referrer"
            href={linkedInLink}
          >
            <DropdownMenu.DropdownItem icon={<FeatherLinkedin />}>
              LinkedIn
            </DropdownMenu.DropdownItem>
          </a>
          <a
            className="contents"
            target="_blank"
            referrerPolicy="no-referrer"
            href={facebookLink}
          >
            <DropdownMenu.DropdownItem icon={<FeatherFacebook />}>
              Facebook
            </DropdownMenu.DropdownItem>
          </a>
          {/* <a
            className="contents"
            target="_blank"
            referrerPolicy="no-referrer"
            href={mastodonLink}
          >
            <DropdownMenu.DropdownItem icon={<FeatherMastodon />}>
              Mastodon
            </DropdownMenu.DropdownItem>
          </a> */}
          <a className="contents" onClick={onCopyLinkClick}>
            <DropdownMenu.DropdownItem icon={<FeatherCopy />}>
              Copy link
            </DropdownMenu.DropdownItem>
          </a>
        </DropdownMenu>
      </SfCDropdownMenu.Content>
    </SfCDropdownMenu.Root>
  );
};

export default ShareButton;
